module.exports = __webpack_public_path__ + "static/media/Share.9060e26a.svg";